import React, {useEffect} from "react";
import "./ContextMenu.scss";

const ContextMenu = (props) => {
  const onClick = () => {
    document.removeEventListener("click", onClick);
    props.onClose();
  }
  useEffect(() => {
    document.addEventListener("click", onClick);
  }, []);

  const itemHtml = props.items.map((item, index) => {
    return item.enabled ? <li key={index} onClick={item.action}>{item.caption}</li> : <li key={index} className={'disabled'}>{item.caption}</li>
  })

  return  <ul className="context-menu" style={{top: props.menuY + "px", left: props.menuX + "px"}}>
    {itemHtml}
  </ul>
}

export default ContextMenu;